module.exports = __webpack_public_path__ + "img/7a75d78.png";